import React, { useState, useEffect, useContext } from "react";
import AdminContext from "../../../StateContext/Application";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext";

const SantionWorkList = () => {
  const { t } = useLanguage();
  const context = useContext(AdminContext);
  const { GetGRbyProposalId ,Usermenu} = context;
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [bills, setBills] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [RoleID, setRoleID] = useState(null);
  const billsPerPage = 10;
  const sortedBills = [...filteredBills];
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills.slice(indexOfFirstBill, indexOfLastBill);
    const totalPages = Math.ceil(filteredBills.length / billsPerPage);
        const [SelectedTalukasofDistrict, setSelectedTalukasofDistrict] =
      useState("");
    
    const [TalukasofDistrict, setTalukasofDistrict] = useState([]);
  useEffect(() => {
    getallGR();
    getmenu()
  }, [id]);
  const getallGR = async () => {
    try {
      setLoading(true);

      const response = await GetGRbyProposalId(id);

      const resData = response?.data;
      console.log("resssssss", resData);

      setBills(Array.isArray(resData) ? resData : []);
      setFilteredBills(resData);

      // Log API data directly (correct way)
      console.log("GR Records:", resData);
    } catch (error) {
      console.error("Error fetching GR data:", error);
      setBills([]);
      setFilteredBills([]);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   const queryParams = new URLSearchParams(location.search);
  //   const statusParam = queryParams.get("status");

  //   let filtered = bills;

  //   // 🔹 Status Filter
  //   if (statusParam === "GR Created") {
  //     filtered = filtered.filter((bill) => bill.GRCreated === true);
  //   } else if (statusParam === "Pending") {
  //     filtered = filtered.filter((bill) => bill.GRCreated === false);
  //   }

  //   // 🔹 Search Filter
  //   if (searchTerm) {
  //     const lowerSearchTerm = searchTerm.toLowerCase();

  //     filtered = filtered.filter((bill) =>
  //       Object.values(bill).some((value) =>
  //         (value || "").toString().toLowerCase().includes(lowerSearchTerm),
  //       ),
  //     );
  //   }

  //   setFilteredBills(filtered);
  //   setCurrentPage(1);
  // }, [bills, location.search, searchTerm]);
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const statusParam = queryParams.get("status");
  
    let talukaData = [...bills];
  
    // 🔹 Apply same status filter as table
    if (statusParam === "GR Created") {
      talukaData = talukaData.filter(
        (bill) => bill.GRCreated === "Created"
      );
    } else if (statusParam === "Pending") {
      talukaData = talukaData.filter(
        (bill) => bill.GRCreated === "Pending"
      );
    } else if (statusParam === "Rejected") {
      talukaData = talukaData.filter(
        (bill) => bill.GRCreated === "Rejected"
      );
    } else {
      // Default: remove rejected
      talukaData = talukaData.filter(
        (bill) => bill.GRCreated !== "Rejected"
      );
    }
  
    // 🔹 Get unique Talukas after status filtering
    const uniqueTalukas = [
      ...new Set(
        talukaData
          .map((bill) => bill.Taluka)
          .filter(
            (taluka) =>
              taluka &&
              taluka.toString().trim() !== ""
          )
      ),
    ];
  
    setTalukasofDistrict(uniqueTalukas);
  
  }, [bills, location.search]);

useEffect(() => {
  const queryParams = new URLSearchParams(location.search);
  const statusParam = queryParams.get("status");

  let filtered = bills;

  // 🔹 Status Filter
  if (statusParam === "GR Created") {
    filtered = filtered.filter(
      (bill) => bill.GRCreated === "Created"
    );
  } 
  else if (statusParam === "Pending") {
    filtered = filtered.filter(
      (bill) => bill.GRCreated === "Pending"
    );
  }

  // 🔹 Always remove rejected
  filtered = filtered.filter(
    (bill) => bill.GRCreated !== "Rejected"
  );

  // 🔹 Search Filter
  if (searchTerm) {
    const lowerSearchTerm = searchTerm.toLowerCase();

    filtered = filtered.filter((bill) =>
      Object.values(bill).some((value) =>
        (value || "")
          .toString()
          .toLowerCase()
          .includes(lowerSearchTerm)
      )
    );
  }
  if (SelectedTalukasofDistrict) {
    filtered = filtered.filter(
      (bill) =>
        bill.Taluka?.toString().trim() ===
        SelectedTalukasofDistrict.toString().trim()
    );
  }


  setFilteredBills(filtered);
  setCurrentPage(1);

}, [bills, location.search, searchTerm,SelectedTalukasofDistrict]);
  const getmenu = async () => {
    try {
      const data = await Usermenu();
      if (!data || typeof data !== "object") {
        console.error("Invalid data:", data);
        return;
      }
      const roleID = data?.Data?.RoleID;
      setRoleID(roleID);
    } catch (error) {
      console.error("Error in AdminNavbar getmenu:", error);
    }
  };
  return (
    <div
      className="col-12 pb-5"
      style={{
        backgroundColor: "#EFF3F8",
        height: "90vh",
        overflowY: "scroll",
      }}
    >
      <div className="col-11 m-auto">
        <div className="col-12">
          {/* <button
            className="btn btn-danger px-3 rounded-4 mb-2 mt-2"
            onClick={() => navigate("/AdminDashboard/GRSanctionWork")}
          >
            {t("Back")}
          </button> */}
            <button
  className="btn btn-danger px-3 rounded-4 mb-2 mt-2"
  onClick={() =>
    navigate("/AdminDashboard/GRSanctionWork", {
      state: { filters: location.state?.filters }
    })
  }
>
  {t("Back")}
</button>
        </div>

        {/* HEADER */}
        <div className="d-flex justify-content-between align-items-center mt-3 mb-4">
          <h5 className="fw-bold">{id ? `${t("GR List")} ` : t("GR List")}</h5>
            <div style={{    display: "flex",
    alignItems: "center",
    gap: "10px",
    margin: "10px",}}>
  <select
    value={SelectedTalukasofDistrict}
    onChange={(e) =>
      setSelectedTalukasofDistrict(e.target.value)
    }
    style={{
      width: "100%",
      padding: "8px",
      border: "1px solid #ccc",
      borderRadius: "8px",
      backgroundColor: "#fff",
      fontSize: "13px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }}
  >
    <option value="">
      {t("Select Taluka")}
    </option>

    {TalukasofDistrict?.map((val, index) => (
      <option key={index} value={val}>
        {val}
      </option>
    ))}
  </select>
          <input
            type="text"
            placeholder={t("Search Here")}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: "250px",
              padding: "5px",
              borderRadius: "8px",
              border: "1px solid #ccc",
            }}
          />
        </div>
        </div>

        {/* TABLE */}
        <div
          className="col-12 tableDesign"
          style={{
            background: "white",
            borderRadius: "20px",
            boxShadow: "0px 0px 5px 1px #E4E8EC",
            padding: "20px",
          }}
        >
          <div
            style={{
              background: "#2C78DB",
              overflowX: "auto",
            }}
          >
            <table
              className="m-0 p-0 ProposalstatusReport"
              style={{ width: "100%", borderCollapse: "collapse" }}
            >
              <thead>
                <tr
                  style={{
                    color: "white",
                    height: "3rem",
                    fontSize: "18px",
                    fontWeight: "400",
                  }}
                >
                  <th style={{ padding: "8px" }}>{t("Sr No")}</th>
                  <th style={{ padding: "8px" }}>{t("Proposal ID")}</th>
                  <th style={{ padding: "8px" }}>{t("Work Name")}</th>
                 {RoleID==29 ? <th style={{ padding: "8px" }}>{t("Head Code")}</th>:""}
                  <th style={{ padding: "8px" }}>{t("Approval Year")}</th>
                  <th style={{ padding: "8px" }}>{t("Taluka")}</th>
                  <th style={{ padding: "8px" }}>{t("Constituency")}</th>
                  <th style={{ padding: "8px" }}>{t("Work Amount")}</th>
                  <th style={{ padding: "8px" }}>{t("Status")}</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td
                      colSpan={9}
                      style={{ textAlign: "center", padding: "15px" }}
                    >
                      Loading...
                    </td>
                  </tr>
                ) : currentBills.length === 0 ? (
                  <tr>
                    <td
                      colSpan={9}
                      style={{ textAlign: "center", padding: "15px" }}
                    >
                      {t("No Data Available")}
                    </td>
                  </tr>
                ) : (
                  currentBills.map((bill, index) => (
                    <tr
                      // key={`${bill.ProposalID}-${index}`}
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "#E5F4FB" : "#CFE4F1",
                        fontSize: "18px",
                        fontWeight: "400",
                      }}
                    >
                      <td style={{ padding: "8px" }}>
                        {indexOfFirstBill + index + 1}
                      </td>

                      <td style={{ padding: "8px" }}>{bill.ProposalID}</td>

                      <td style={{ padding: "8px" }}>{bill.WorkName}</td>

                       {RoleID==29 ? <td style={{ padding: "8px" }}>{bill.HeadCode}</td>:""}

                      <td style={{ padding: "8px" }}>{bill.ApprovalYear}</td>

                      <td style={{ padding: "8px" }}>{bill.Taluka}</td>

                      <td style={{ padding: "8px" }}>
                        {bill.ConstituencyName}
                      </td>

                      <td style={{ padding: "8px" }}>{bill.WorkAmount}</td>

                      <td style={{ padding: "8px" }}>
                        {bill.GRCreated=="Created" ? "GR Created" : "Pending"}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* PAGINATION */}
          {/* <div className="col-12 mt-4 mb-2">
            <div className="row">
              <div className="col-6">
                <p
                  style={{
                    fontSize: "14px",
                    margin: 0,
                  }}
                >
                  Showing {indexOfFirstBill + 1} to{" "}
                  {Math.min(indexOfLastBill, sortedBills.length)} of{" "}
                  {sortedBills.length} entries
                </p>
              </div>
            </div>
          </div> */}
          <div className="col-12 mt-4 mb-2">
  <div className="row">
    <div className="col-6">
      <p
        style={{
          fontSize: "18px",
          margin: 0,
        }}
      >
        Showing {indexOfFirstBill + 1} to{" "}
        {Math.min(indexOfLastBill, sortedBills.length)} of{" "}
        {sortedBills.length} entries
      </p>
    </div>

    <div
      className="col-6"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "end",
      }}
    >
      {/* First Page */}
      <button
        onClick={() => setCurrentPage(1)}
        disabled={currentPage === 1}
        style={{
          backgroundColor: "white",
          color: "black",
          border: "1px solid lightgrey",
          cursor: "pointer",
          fontSize: "20px",
          width: "2rem",
        }}
      >
        &laquo;
      </button>

      {/* Previous */}
      <button
        onClick={() => setCurrentPage(currentPage - 1)}
        disabled={currentPage === 1}
        style={{
          backgroundColor: "white",
          color: "black",
          border: "1px solid lightgrey",
          cursor: "pointer",
          fontSize: "20px",
          borderLeft: "none",
          width: "2rem",
        }}
      >
        &lt;
      </button>

      {/* Current Page */}
      <button
        style={{
          background:
            "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
          color: "white",
          cursor: "pointer",
          fontSize: "20px",
          width: "2.4rem",
          border: "1px solid lightgrey",
          borderLeft: "none",
        }}
      >
        {currentPage}
      </button>

      {/* Next */}
      <button
        onClick={() => setCurrentPage(currentPage + 1)}
        disabled={currentPage === totalPages || totalPages === 0}
        style={{
          backgroundColor: "white",
          color: "black",
          border: "1px solid lightgrey",
          cursor: "pointer",
          fontSize: "20px",
          borderLeft: "none",
          width: "2rem",
        }}
      >
        &gt;
      </button>

      {/* Last Page */}
      <button
        onClick={() => setCurrentPage(totalPages)}
        disabled={currentPage === totalPages || totalPages === 0}
        style={{
          backgroundColor: "white",
          color: "black",
          border: "1px solid lightgrey",
          cursor: "pointer",
          fontSize: "20px",
          borderLeft: "none",
          width: "2rem",
        }}
      >
        &raquo;
      </button>
    </div>
  </div>
</div>

        </div>
      </div>
    </div>
  );
};

export default SantionWorkList;
